import { useQuery } from "@tanstack/react-query";
import { InspectionsListAll } from "../services";
import type { InspectionFilters, InspectionsResponse } from "../types";

export const useGetInspections = (filters: InspectionFilters) =>
	useQuery<InspectionsResponse>({
		queryKey: ["inspections", filters],
		queryFn: () => InspectionsListAll(filters),
	});
